"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVALID_HASH = exports.IMPROPPER_FORMATTING = void 0;
var IMPROPPER_FORMATTING = 'Anchor path should contain an absolute root path `/` and selector `#` Ex: `/about#team`';
exports.IMPROPPER_FORMATTING = IMPROPPER_FORMATTING;
var INVALID_HASH = 'Anchor Links plugin attempted to scroll to an invalid hash on route change.';
exports.INVALID_HASH = INVALID_HASH;